import { PropertyRepository } from 'application/repositories/PropertyRepository';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';
import { ContractResponse } from 'domain/entities/ContractEntity';
import {
    AuctionPriceLimitUpdate,
    DataListedProperty,
    DataProperty,
    DetailMemberAuctionResponse,
    EvictionListedProperty,
    ListedPropertyAssessmentDetailPayload,
    ListedPropertyAssessmentMain,
    ListedPropertyDetail,
    ListedPropertyFilter,
    ListedPropertyInquiresCreate,
    ListedPropertyRoomAssessment,
    ListedPropertyRoomGetAssessmentDetail,
    ListedPropertySalePriceLimitUpdate,
    ParamsProperty,
    PropertyDetailEntity,
    PropertyListEntity,
} from 'domain/entities/PropertyEntity';
import { SellingPriceResult } from 'presentation/pages/CU/CU-036-01/models/Property';
import { CU049SearchParams } from 'presentation/pages/CU/CU-049-01/models/Model_CU-049-01';

export class PropertyUseCase implements PropertyUseCaseInterface {
    private propertyRepo: PropertyRepository;
    constructor(propertyRepo: PropertyRepository) {
        this.propertyRepo = propertyRepo;
    }

    async getListedPropertiesList(params: {
        page: number;
        pageSize: number;
        keyword: string;
        buyNowPriceMin?: number;
        buyNowPriceMax?: number;
        oldMin?: number;
        oldMax?: number;
        areaId?: string;
        isLogin?: number;
    }): Promise<PropertyListEntity> {
        return await this.propertyRepo.getListedPropertiesList(params);
    }

    async getListProperty(params: ParamsProperty): Promise<DataProperty[]> {
        return await this.propertyRepo.getListProperty(params);
    }

    async getDetailProperty(params: { propertyId: number }): Promise<PropertyDetailEntity> {
        return await this.propertyRepo.getDetailProperty(params);
    }

    async getPropertyArea(params: ParamsProperty): Promise<DataListedProperty[]> {
        return await this.propertyRepo.getPropertyArea(params);
    }

    async getListedPropertyDetail(params: {
        ListedPropertyId: number;
    }): Promise<ListedPropertyDetail> {
        return await this.propertyRepo.getListedPropertyDetail(params);
    }

    async getListedPropertyRoomGetAssessmentDetail(params: {
        listedPropertyId: number;
    }): Promise<ListedPropertyRoomGetAssessmentDetail> {
        return await this.propertyRepo.getListedPropertyRoomGetAssessmentDetail(params);
    }

    async postListedPropertyInquiriesCreate(
        data: ListedPropertyInquiresCreate,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.postListedPropertyInquiriesCreate(data);
    }

    async postListedPropertyRoomAssessment(
        data: ListedPropertyRoomAssessment,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.postListedPropertyRoomAssessment(data);
    }

    async putListedPropertyAssessmentDetail(
        data: ListedPropertyAssessmentDetailPayload,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.putListedPropertyAssessmentDetail(data);
    }
    async putListedPropertyAssessmentMain(
        data: ListedPropertyAssessmentMain,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.putListedPropertyAssessmentMain(data);
    }
    async putListedPropertySalePriceLimitUpdate(
        data: ListedPropertySalePriceLimitUpdate,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.putListedPropertySalePriceLimitUpdate(data);
    }
    async auctionPriceLimitUpdate(
        data: AuctionPriceLimitUpdate,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.auctionPriceLimitUpdate(data);
    }
    async getListedPropertyFilter(params: {
        page?: number;
        pageSize: number;
        buyNowPriceMin?: number;
        buyNowPriceMax?: number;
        oldMin?: number;
        oldMax?: number;
        areaId?: number;
    }): Promise<ListedPropertyFilter> {
        return await this.propertyRepo.getListedPropertyFilter(params);
    }

    async getMasterPropertyFilterArea(params: CU049SearchParams): Promise<ListedPropertyFilter> {
        return await this.propertyRepo.getMasterPropertyFilterArea(params);
    }
    async getMasterPropertyFilterStation(params: CU049SearchParams): Promise<ListedPropertyFilter> {
        return await this.propertyRepo.getMasterPropertyFilterStation(params);
    }
    async putEvictionListedProperty(
        data: EvictionListedProperty,
    ): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.putEvictionListedProperty(data);
    }

    async cancelListedProperty(data: EvictionListedProperty): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.cancelListedProperty(data);
    }

    async memberBookMarkListedProperty(params: {
        listedPropertyId: number;
    }): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.memberBookMarkListedProperty(params);
    }

    async countLike(listedPropertyId: number): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.countLike(listedPropertyId);
    }

    async updateCurrentProcess(params: {
        listedPropertyId: number;
        step: number;
    }): Promise<PostPutDeleteBaseResponse> {
        return await this.propertyRepo.updateCurrentProcess(params);
    }
    async getDetailAuctionOfMember(params: {
        listedPropertyId: number;
        isLogin?: number;
    }): Promise<DetailMemberAuctionResponse> {
        return await this.propertyRepo.getDetailAuctionOfMember(params);
    }
    async getAssessmentStatus(params: { mstPropertyId: number }): Promise<any> {
        return await this.propertyRepo.getAssessmentStatus(params);
    }
    async getDefaultSellingPrice(params: {
        listedPropertyId: number;
    }): Promise<SellingPriceResult> {
        return await this.propertyRepo.getDefaultSellingPrice(params);
    }
    async getSellingPrice(params: { auctionId: number }): Promise<any> {
        return await this.propertyRepo.getSellingPrice(params);
    }
    async checkCancelListedProperty(params: { auctionId: number }): Promise<any> {
        return await this.propertyRepo.checkCancelListedProperty(params);
    }
    async checkChangeSellingPrice(params: { auctionId: number }): Promise<any> {
        return await this.propertyRepo.checkChangeSellingPrice(params);
    }
    async getListPropertisDashboard(params: { tabId: number; type: number }): Promise<any> {
        return await this.propertyRepo.getListPropertisDashboard(params);
    }
    async getConfirmContract(params: { listedPropertyId: number }): Promise<ContractResponse> {
        return await this.propertyRepo.getConfirmContract(params);
    }
    async confirmContract(payload: { agencyContractId: number }): Promise<any> {
        return await this.propertyRepo.confirmContract(payload);
    }
    async processBeforePeriod(payload: {
        auctionId: string;
        type: string;
        askingSalePriceUpperLimit: number;
        askingSalePriceLowerLimit: number;
        listedPropertyId: number;
        dealId: number;
    }): Promise<any> {
        return await this.propertyRepo.processBeforePeriod(payload);
    }
}
export interface PropertyUseCaseInterface {
    getListedPropertiesList(params: {
        page: number;
        pageSize: number;
        keyword: string;
        buyNowPriceMin?: number;
        buyNowPriceMax?: number;
        oldMin?: number;
        oldMax?: number;
        areaId?: string;
        isLogin?: number;
        filter?: number;
    }): Promise<PropertyListEntity>;
    getListProperty(params: ParamsProperty): Promise<DataProperty[]>;
    getDetailProperty(params: { propertyId: number }): Promise<PropertyDetailEntity>;
    getPropertyArea(params: {
        page?: number;
        pageSize: number;
        buyNowPriceMin?: number;
        buyNowPriceMax?: number;
        oldMin?: number;
        oldMax?: number;
        areaId?: number | string;
        keyword?: string;
    }): Promise<DataListedProperty[]>;
    getListedPropertyDetail(params: { ListedPropertyId: number }): Promise<ListedPropertyDetail>;
    postListedPropertyInquiriesCreate(
        data: ListedPropertyInquiresCreate,
    ): Promise<PostPutDeleteBaseResponse>;
    postListedPropertyRoomAssessment(
        data: ListedPropertyRoomAssessment,
    ): Promise<PostPutDeleteBaseResponse>;
    getListedPropertyRoomGetAssessmentDetail(params: {
        listedPropertyId: number;
    }): Promise<ListedPropertyRoomGetAssessmentDetail>;
    putListedPropertyAssessmentDetail(
        data: ListedPropertyAssessmentDetailPayload,
    ): Promise<PostPutDeleteBaseResponse>;
    getListedPropertyFilter(params: {
        page?: number;
        pageSize: number;
        buyNowPriceMin?: number;
        buyNowPriceMax?: number;
        oldMin?: number;
        oldMax?: number;
        areaId?: number;
    }): Promise<ListedPropertyFilter>;
    getMasterPropertyFilterArea(params: CU049SearchParams): Promise<ListedPropertyFilter>;
    getMasterPropertyFilterStation(params: CU049SearchParams): Promise<ListedPropertyFilter>;
    putListedPropertyAssessmentMain(
        data: ListedPropertyAssessmentMain,
    ): Promise<PostPutDeleteBaseResponse>;
    putListedPropertySalePriceLimitUpdate(
        data: ListedPropertySalePriceLimitUpdate,
    ): Promise<PostPutDeleteBaseResponse>;
    putEvictionListedProperty(data: EvictionListedProperty): Promise<PostPutDeleteBaseResponse>;
    cancelListedProperty(data: EvictionListedProperty): Promise<PostPutDeleteBaseResponse>;
    memberBookMarkListedProperty(params: {
        listedPropertyId: number;
    }): Promise<PostPutDeleteBaseResponse>;

    countLike(listedPropertyId: number): Promise<PostPutDeleteBaseResponse>;

    updateCurrentProcess(params: {
        listedPropertyId: number;
        step: number;
    }): Promise<PostPutDeleteBaseResponse>;
    getDetailAuctionOfMember(params: {
        listedPropertyId: number;
        isLogin?: number;
    }): Promise<DetailMemberAuctionResponse>;
    auctionPriceLimitUpdate(data: AuctionPriceLimitUpdate): Promise<PostPutDeleteBaseResponse>;
    getAssessmentStatus(params: { mstPropertyId: number }): Promise<any>;
    getDefaultSellingPrice(params: { listedPropertyId: number }): Promise<SellingPriceResult>;
    getSellingPrice(params: { auctionId: number }): Promise<any>;
    checkCancelListedProperty(params: { auctionId: number }): Promise<any>;
    checkChangeSellingPrice(params: { auctionId: number }): Promise<any>;
    getListPropertisDashboard(params: { tabId: number; type: number }): Promise<any>;
    getConfirmContract(params: { listedPropertyId: number }): Promise<ContractResponse>;
    confirmContract(payload: { agencyContractId: number }): Promise<any>;
    processBeforePeriod(payload: {
        auctionId: string;
        type: string;
        askingSalePriceUpperLimit: number;
        askingSalePriceLowerLimit: number;
        listedPropertyId: number;
        dealId: number;
    }): Promise<any>;
}
